const createGroupsStore = (set) => ({
  groupsList: [],
  isLoading: false,

  setGroups: (groups) =>
    set((state) => ({
      superadmin: {
        ...state.superadmin,
        groups: {
          ...state.superadmin.groups,
          groupsList: groups,
        },
      },
    })),

  setLoading: (isLoading) =>
    set((state) => ({
      superadmin: {
        ...state.superadmin,
        groups: {
          ...state.superadmin.groups,
          isLoading,
        },
      },
    })),

  updateGroup: (groupId, updatedData) =>
    set((state) => ({
      superadmin: {
        ...state.superadmin,
        groups: {
          ...state.superadmin.groups,
          groupsList: state.superadmin.groups.groupsList.map((grp) =>
            grp?.id === groupId ? updatedData : grp
          ),
        },
      },
    })),

  // Reset store to initial state
  reset: () =>
    set((state) => ({
      superadmin: {
        ...state.superadmin,
        groups: {
          groupsList: [],
          isLoading: false,
        },
      },
    })),
});

export default createGroupsStore;
